import { GateTypes } from '@/types/registration.types';
import { checkIsDomainInvalid } from '@/utils/domain-regex';

const NON_WHITESPACE_REGEX = /\S/;

export type GatingErrors = Partial<Record<'domain_email' | 'shared_passcode', string>>;

export type DomainTab = 'allow' | 'block';

type Args = {
  access: GateTypes | null;
  domainTab: DomainTab;
  allowDomains: string[];
  blockDomains: string[];
  sharedPasscode: string;
};

const validateGatingSettings = ({
  access,
  domainTab,
  allowDomains,
  blockDomains,
  sharedPasscode,
}: Args): GatingErrors | null => {
  const errors: GatingErrors = {};

  if (access === GateTypes.domain_email) {
    const activeList = domainTab === 'allow' ? allowDomains : blockDomains;
    const tabLabel = domainTab === 'allow' ? 'allowed' : 'blocked';
    if (!activeList.length) {
      errors.domain_email = `Must include at least one ${tabLabel} domain`;
    } else {
      const firstInvalidError = activeList.map((d) => checkIsDomainInvalid(d)).find((err) => err);
      if (firstInvalidError) {
        errors.domain_email = firstInvalidError;
      }
    }
  }

  if (access === GateTypes.shared_passcode) {
    if (!sharedPasscode) {
      errors.shared_passcode = 'Passcode field must have a value';
    } else if (!NON_WHITESPACE_REGEX.test(sharedPasscode)) {
      errors.shared_passcode = 'Passcode must have at least one character';
    }
  }

  return Object.keys(errors).length ? errors : null;
};

export default validateGatingSettings;
